export const EMPTY_OPTION_VALUE = 'EMPTY_OPTION';
